import useHook, { Props } from './hooks'
import style from './style.module.scss'
export default function RadioTabs(props: Props) {
  const { currentKey, radioItemDict, handleRadioChange } = useHook(props)
  return (
    <div className={style['tab-group']}>
      {Object.keys(radioItemDict).map((key) => {
        return (
          <div
            className={[
              style['tab-item'],
              key === currentKey ? style['item-checked'] : '',
            ].join(' ')}
            key={key}
            onClick={() => {
              handleRadioChange(key)
            }}
          >
            {radioItemDict[key].value || radioItemDict[key].keyName}
          </div>
        )
      })}
    </div>
  )
}
import useHook, { Props } from './hooks'
import style from './style.module.scss'
export default function RadioTabs(props: Props) {
  const { currentKey, radioItemDict, handleRadioChange } = useHook(props)
  return (
    <div className={style['tab-group']}>
      {Object.keys(radioItemDict).map((key) => {
        return (
          <div
            className={[
              style['tab-item'],
              key === currentKey ? style['item-checked'] : '',
            ].join(' ')}
            key={key}
            onClick={() => {
              handleRadioChange(key)
            }}
          >
            {radioItemDict[key].value || radioItemDict[key].keyName}
          </div>
        )
      })}
    </div>
  )
}
